import React from 'react';

export const indexHero = [
  {
    title: 'Move at the Speed of Digital',
    subtitle: (
      <>
        Innovative Solutions Driving Breakthrough
        <br />
        Results
      </>
    ),
    image: 'index-hero-1.jpg',
  },
  {
    title: 'Products That Solve Customer Problems',
    subtitle: (
      <>
        Solve complex problems with surprisingly
        <br />
        simple solutions
      </>
    ),
    image: 'index-hero-2.jpg',
  },
  {
    title: 'Embrace The Present',
    subtitle:
      'Maintain your competitive edge by keeping your business at the forefront of technology',
    image: 'index-hero-3.jpg',
  },
];

export const indexSolutions = [
  {
    id: 1,
    title: 'Kubernetes',
    excerpt:
      'Automate application deployment in a highly scalable and manageable way using the best Container-Orchestration System on the planet.',
    link: '/solutions/kubernetes/',
  },
  {
    id: 2,
    title: 'Cloud Transformation',
    excerpt:
      'Enterprise agility via “The Cloud” has not only negated the need for tech infrastructure, but has delivered it in a more secure, cost-effective, and scalable on-demand resource.',
    link: '/solutions/cloud-transformation/',
  },
  {
    id: 3,
    title: 'Robotic Process Automation (RPA)',
    excerpt:
      "Reduce costs, multitask, and get faster results from automated BOTs that never call in sick. RPA is capable of imitating actions that humans take on a computer. Deploy 100's of BOTs to manage your entire workflow with ZERO errors around the clock.",
    link: '/solutions/robotic-process-automation/',
  },
  {
    id: 4,
    title: 'Blockchain Development',
    excerpt:
      'Blockchain is a distributed database that provides a secure, yet transparent way to make, record and verify any type of transaction.',
    link: '/solutions/blockchain-development/',
  },
  {
    id: 5,
    title: 'Chatbots and Voice Assistant',
    excerpt:
      'Make your products more human. Connect all of your products with Voice via Google Assistant Skill, Amazon Alexa Skill.',
    link: '/solutions/chatbots-voice-assistant/',
  },
  {
    id: 6,
    title: 'Custom Application Development',
    excerpt:
      'Consolidating multi-faceted expertise under one roof allows for seamless product building. Modern and intuitive SaaS products bring enterprise ideas to life.',
    link: '/solutions/custom-application-development/',
  },
  {
    id: 7,
    title: 'SAFe Transformation',
    excerpt:
      'Lean-Agile Transformation is a journey from the legacy waterfall model in SDLC to time-boxed sprints, improving quality, reducing cost, and accelerating delivery.',
    link: '/solutions/safe-transformation/',
  },
  {
    id: 8,
    title: 'Software Quality',
    excerpt:
      'Independent software quality assurance (QA) services delivers valuable insights into end-user impression, bug detection, and more effective control of your application quality including revision of compliance and original requirements.',
    link: '/solutions/testing/',
  },
  {
    id: 9,
    title: 'Business Intelligence',
    excerpt:
      'Timely and effective decisions are critical. Businesses need the insight to identify changes and adapt their approach. ',
    link: '/solutions/business-intelligence/',
  },
];

export const aboutTabs = [
  {
    title: 'Passionate people with a singular goal: client success',
    excerpt:
      'Our mission is to wake up every day driven to meet the needs of our clients and enable their ability to compete by providing the latest technological solutions to give them an edge against their competitors.',
  },
  {
    title:
      'Making complex technologies uncomplicated empowers our client’s to win',
    excerpt:
      'At ATC we keep an eye on the future, innovate continuously and integrate disruptive technologies into breakthrough solutions. This is how we partner with companies to move them forward and help them win.',
  },
  {
    title: 'Embrace change and innovation to deliver the best solutions',
    excerpt: (
      <>
        Your unique business needs are tended to by our customized approach to
        onsite consulting, offshore resources, enterprise-grade tools, and
        high-quality staff placement services.
        <br />
        We use the resources and expertise that we have gathered in the last
        decade to help you bridge key knowledge, technology, and process gaps,
        allowing you to accelerate growth and build a competitive edge. Founded
        in 2008 during the peak of the economic downturn, the professionalism
        and forward-thinking of our passionate team has enabled us to grow into
        an organization well-equipped to lead, support, and optimize your IT
        initiatives.
      </>
    ),
  },
];

export const socialLinks = {
  twitter: 'https://twitter.com/atc1team',
  facebook: 'https://www.facebook.com/atc1team/',
  linkedin: 'https://www.linkedin.com/company/american-technology-consulting',
  youtube: 'https://www.youtube.com/channel/UCrBD2N9S63sa6Q9XNcFvtPw',
};

export const clientsIcons = [
  {
    url: '/clients/01-crystal-run-healthcare.svg',
    title: 'crystal run healthcare',
  },
  {
    url: '/clients/02-kloudone.svg',
    title: 'kloudone',
  },
  {
    url: '/clients/03-perfect-global.svg',
    title: 'perfect global',
  },
  {
    url: '/clients/04-mobiport.svg',
    title: 'mobiport',
  },
  {
    url: '/clients/05-principal.svg',
    title: 'principal',
  },
  {
    url: '/clients/06-fhlb.svg',
    title: 'fhlb',
  },
  {
    url: '/clients/07-auzmor.svg',
    title: 'auzmor',
  },
  {
    url: '/clients/08-meredith.svg',
    title: 'meredith',
  },
  {
    url: '/clients/09-mediacom.svg',
    title: 'mediacom',
  },
  {
    url: '/clients/10-delta-dental.svg',
    title: 'delta dental',
  },
  {
    url: '/clients/11-lightedge.svg',
    title: 'lightedge',
  },
  {
    url: '/clients/12-tusker.svg',
    title: 'tusker',
  },
];

export const solutionsStepsData = {
  about: [
    {
      id: 1,
      title: 'Fearlessness',
      excerpt: (
        <p>
          We embrace change and innovation in order to deliver the best
          solutions.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Humility',
      excerpt: (
        <p>We are committed to a culture of teamwork and collaboration.</p>
      ),
    },
    {
      id: 3,
      title: 'Inclusiveness',
      excerpt: (
        <p>We respect people, value diversity and are committed to equality.</p>
      ),
    },
    {
      id: 4,
      title: 'Learning',
      excerpt: <p>We believe the future belongs to the learners.</p>,
    },
    {
      id: 5,
      title: 'Genuine',
      excerpt: <p>We deliver on our promises.</p>,
    },
    {
      id: 6,
      title: 'Customers',
      excerpt: <p>We exist to meet the needs of our customers.</p>,
    },
  ],
  enterpriseApplicationDevelopment: [
    {
      id: 1,
      title: 'Scalability',
      excerpt: (
        <p>
          Software as a Service (SaaS) is perhaps the most conducive for the
          Agile and DevOps model of software development as it is far easier to
          deploy, maintain, and upgrade than conventional software while
          simultaneously being more accessible to the end users.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Time-to-market',
      excerpt: (
        <p>
          ATC leverages Rapid Application Development, Continuous Integration,
          and Continuous Delivery to dramatically cut down time to market for
          SaaS products while enabling faster upgrades based on user feedback.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Hybrid',
      excerpt: (
        <p>
          ATC’s hybrid model combines the best of offshore and onshore
          development purely based on scope and complexity of the project,
          empowers lean startups who do not have the bandwidth to deploy
          resources required to design, build, and manage apps.
        </p>
      ),
    },
  ],
  kubernetes: [
    {
      id: 1,
      title: 'Consulting & Advisory',
      excerpt: (
        <ul>
          <li>Intro to Containers &amp; Kubernetes</li>
          <li>Container Strategy &amp; Architecture Workshop</li>
          <li>Hands-on Workshop</li>
          <li>Containerize Services</li>
          <li>Minikube Cluster</li>
          <li>Service migration to Production</li>
        </ul>
      ),
    },
    {
      id: 2,
      title: 'Setup & Implementation',
      excerpt: (
        <ul>
          <li>Solidify K8s architecture &amp; tooling decisions</li>
          <li>Construction of Kubernetes</li>
          <li>Construction of Application Continuous Delivery Pipelines</li>
          <li>Operations Training</li>
        </ul>
      ),
    },
    {
      id: 3,
      title: 'Managed Services',
      excerpt: (
        <ul>
          <li>24x7 Enterprise Kubernetes Enterprise Support</li>
          <li>Stand up Tier 1/2 Helpdesk based on Discovery</li>
          <li>New Release Management</li>
        </ul>
      ),
    },
  ],
  cloudTransformation: [
    {
      id: 1,
      title: 'Consulting',
      excerpt: (
        <ul>
          <li>Advisory and Assessment</li>
          <li>Cloud Readiness and Economics Assessment</li>
          <li>TCO Analysis</li>
          <li>ROI Analysis</li>
          <li>Portfolio and Application Readiness Assessment</li>
          <li>Cloud Reference Architecture</li>
          <li>Capabilities Matrix</li>
          <li>Application Cloud Roadmap &amp; Plans</li>
          <li>Current Cloud State Assessment</li>
        </ul>
      ),
    },
    {
      id: 2,
      title: 'Operations',
      excerpt: (
        <ul>
          <li>Minimum Viable Cloud POCs and Pilots</li>
          <li>Infrastructure automation</li>
          <li>Application Migration Factory</li>
          <li>Cloud Operational Model</li>
          <li>Governance, Chargeback, Audit, Logging &amp; Escalation</li>
        </ul>
      ),
    },
    {
      id: 3,
      title: 'Managed Services',
      excerpt: (
        <ul>
          <li>Remote Cloud Infrastructure management</li>
          <li>Expert Account Configuration/Setup</li>
          <li>24*7 Monitoring</li>
          <li>Comprehensive Routine Maintenance</li>
          <li>
            Next-Gen (latest) technologies for efficiency and faster delivery
          </li>
        </ul>
      ),
    },
    {
      id: 4,
      title: 'Security',
      excerpt: (
        <ul>
          <li>Automated Data Collection</li>
          <li>Real-time threat detection</li>
          <li>Rapid Response &amp; Remediation</li>
        </ul>
      ),
    },
  ],
  roboticProcessAutomation: [
    {
      id: 1,
      title: 'Healthcare',
      excerpt: (
        <p>
          Automate processes to dramatically reduce the volume of repetitive
          work, pull repeated reporting, eliminate errors, and mitigate the
          impact of workload peaks.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Banking',
      excerpt: (
        <p>
          Deliver high automation efficiency with ZERO error rates in validating
          and processing trades. Significant reduction in average handling time
          from 40 minutes to 3 minutes to process trades.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Insurance',
      excerpt: (
        <p>
          By automating data extraction and comparison to match and validate
          records, our RPA solution for an insurance company remarkably reduced
          turnaround time by 80%.
        </p>
      ),
    },
    {
      id: 4,
      title: 'Manufacturing',
      excerpt: (
        <p>
          Simplify vendor data management by implementing RPA to extract data
          from forms and validate VAT, IBAN, USPS, ABS, and perform duplication
          checks.
        </p>
      ),
    },
  ],
  blockchainDevelopment: [
    {
      id: 1,
      title: 'Secure',
      excerpt: (
        <p>
          Blockchain is a distributed database that provides a secure, yet
          transparent way to make, record and verify any type of transaction. It
          eliminates the need for centralized control – instead all transactions
          are decentralized, and verified by the blockchain database itself in
          the distributed ledger making it the most secure platform available.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Scalable',
      excerpt: (
        <p>
          Blockchain has the ability to scale to enterprise levels. With
          overwhelming use cases Blockchain can bring to life your next project.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Cloud',
      excerpt: (
        <p>
          Blockchain in the cloud? Yes. We have partnered with multiple cloud
          providers to make your blockchain development project alive in the
          cloud. While this option is not for every use case it does have
          capabilities and features worth considering.
        </p>
      ),
    },
  ],
  testing: [
    {
      id: 1,
      title: 'Functional',
      excerpt: (
        <p>
          Be 100% certain that your application complies with specifications and
          delivers all the functionalities that it was designed for.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Performance',
      excerpt: (
        <p>
          Give your application the edge to set benchmarks for performance under
          different conditions with load and stress tests.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Security',
      excerpt: (
        <p>
          Ensure compliance with stringent regulatory requirements for privacy
          and security by identifying vulnerabilities and guarding against loss
          of data and reputation.
        </p>
      ),
    },
    {
      id: 4,
      title: 'Regression',
      excerpt: (
        <p>
          Gain confidence that none of your releases will break any of the
          features and functionalities of your application.
        </p>
      ),
    },
    {
      id: 5,
      title: 'Compatibility',
      excerpt: (
        <p>
          Give your application the power of true cross-platform performance and
          maintain consistency across operating systems, browsers, and devices.
        </p>
      ),
    },
  ],
  businessIntelligence: [
    {
      id: 1,
      title: 'Unified',
      excerpt: (
        <p>
          Unified reporting that draws from many sources to create a visually
          appealing dashboard to give you insights in detail to make decisions.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Real-time',
      excerpt: (
        <p>
          Leverage real-time data, anytime, to make the business decisions you
          need to make when you need to make them based on today’s information
          rather than the last 30 days.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Advanced Linguistics',
      excerpt: (
        <p>
          Natural Language Generation (NLG) takes structured data and evolves it
          into understandable human language, offering analysis of complex data
          and clear explanation of key metrics.
        </p>
      ),
    },
  ],
  customMobileAppDevelopment: [
    {
      id: 1,
      title: 'Partner',
      excerpt: (
        <p>
          The first step in your app journey is finding a partner. Your partner
          will help you identify the appropriate technologies, tools, and
          application development frameworks for your app, work alongside you to
          bring your app idea to life, and be available to you for ongoing
          assistance for the life of the app.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Purpose',
      excerpt: (
        <p>
          Building an app that provides a solution to your consumer should be
          the purpose of your app. Driving user engagement through UI, the
          front-end, user interface, is key to providing positive user
          experience.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Develop',
      excerpt: (
        <p>
          Once you decide on the UI design, you have to focus on choosing the
          right app development framework that will keep the cost of development
          down while enabling cross-platform app development.
        </p>
      ),
    },
    {
      id: 4,
      title: 'Support',
      excerpt: (
        <p>
          Launching your app is not the final stage of app development. Updates
          are required as real users provide feedback and evolution in the app.
        </p>
      ),
    },
  ],
  enterpriseWebDevelopment: [
    {
      id: 1,
      title: 'Partner',
      excerpt: (
        <p>
          Finding a partner that has the experience and ability to manage your
          whole web application’s tech stack is a priority. Not only is your
          partner responsible for the development of your project, but also
          giving the guidance needed to bring your idea to life, and then to
          market.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Purpose',
      excerpt: (
        <p>
          Ensuring your project is the solution to your consumer’s problem
          should be your first step in determining how to get started. The user
          experience on the tool is directly related to the pain points your
          consumer endures.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Develop',
      excerpt: (
        <p>
          Choosing the right tech stack for your web application should be based
          on flexibility and lightweight structure. It’s important to consider
          your whole stack as one functioning entity for your enterprise.
        </p>
      ),
    },
    {
      id: 4,
      title: 'Support',
      excerpt: (
        <p>
          Product launch is not the end of the project. The web is a constantly
          evolving environment that requires constant updating and the analysis
          of user engagement in order to keep your product up to the level your
          consumer expects.
        </p>
      ),
    },
  ],
  sageTransformation: [
    {
      id: 1,
      title: 'Assessment',
      excerpt: (
        <p>
          Fact-finding with a tried and tested questionnaire and an unbiased
          outlook allows us to interpret facts to determine the readiness of
          your organization for implementing DevOps. We don’t stop with
          identifying the current level of maturity, but go one step further in
          providing an actionable roadmap for improvement.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Automation',
      excerpt: (
        <p>
          There are industry-leading tools across the spectrum of
          automation—infrastructure, configuration, deployment, and monitoring.
          In addition to assessment, we help you identify the right tools that
          are purpose-built to support continuous integration, delivery, and
          deployment.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Management',
      excerpt: (
        <p>
          Improved collaboration between software development and operation
          teams necessitates framing shared responsibilities instead of relying
          on isolated performance metrics. We help optimize performance across
          your teams by:
        </p>
      ),
    },
  ],
  saasProductDevelopment: [
    {
      id: 1,
      title: 'Scalability',
      excerpt: (
        <p>
          Software as a Service (SaaS) is perhaps the most conducive for the
          Agile and DevOps model of software development as it is far easier to
          deploy, maintain, and upgrade than conventional software while
          simultaneously being more accessible to the end users.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Time-to-market',
      excerpt: (
        <p>
          ATC leverages Rapid Application Development, Continuous Integration,
          and Continuous Delivery to dramatically cut down time to market for
          SaaS products while enabling faster upgrades based on user feedback.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Hybrid',
      excerpt: (
        <p>
          ATC’s hybrid model combines the best of offshore and onshore
          development purely based on scope and complexity of the project,
          empowers lean startups who do not have the bandwidth to deploy
          resources required to design, build, and manage apps.
        </p>
      ),
    },
  ],
  chatbotsVoiceAssistant: [
    {
      id: 1,
      title: 'Ease-of-use',
      excerpt: (
        <p>
          Your solution shouldn’t be so complex that employees don’t embrace it.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Performance',
      excerpt: (
        <p>
          Your chatbot functionalities should fulfill all your business
          objectives. Incorporate AI so the bot learns from conversations and
          directives, leading to a greater flexibility and accuracy.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Custom Features',
      excerpt: (
        <p>
          Every enterprise has variables that should be considered when
          selecting any solution. Using an all-in-one approach is insufficient
          as it discounts the priorities and capacities of your business.
        </p>
      ),
    },
    {
      id: 4,
      title: 'Integration',
      excerpt: (
        <p>
          A chatbot should easily integrate with other systems including your
          social media and communication tools to allocate data and feedback
          appropriately.
        </p>
      ),
    },
  ],
  customWebDevelopment: [
    {
      id: 1,
      title: 'Scalability',
      excerpt: (
        <p>
          Software as a Service (SaaS) is perhaps the most conducive for the
          Agile and DevOps model of software development as it is far easier to
          deploy, maintain, and upgrade than conventional software while
          simultaneously being more accessible to the end users.
        </p>
      ),
    },
    {
      id: 2,
      title: 'Time-to-market',
      excerpt: (
        <p>
          ATC leverages Rapid Application Development, Continuous Integration,
          and Continuous Delivery to dramatically cut down time to market for
          SaaS products while enabling faster upgrades based on user feedback.
        </p>
      ),
    },
    {
      id: 3,
      title: 'Hybrid',
      excerpt: (
        <p>
          ATC’s hybrid model combines the best of offshore and onshore
          development purely based on scope and complexity of the project,
          empowers lean startups who do not have the bandwidth to deploy
          resources required to design, build, and manage apps.
        </p>
      ),
    },
  ],
};

export const testimonials = [
  {
    id: 1,
    comment: (
      <>
        &quot;We&apos;ve worked with ATC over the past few years and all I can
        say are good things about them. They are an absolutely great partner to
        work with and are always willing to help. Their team truly go the extra
        mile. We have worked with them on multiple different projects and I
        would definitely recommend them. With ATC you are in great hands.&quot;
      </>
    ),
    author: (
      <>
        <span className="bold">Vishal Sethi</span>
        <br />
        CEO, Perfict Global
      </>
    ),
    bgImage: 'about/client-1.png',
    logo: 'testimonials/logo-perfict-global.png',
  },
  {
    id: 2,
    comment: (
      <>
        &quot;The work we do is of a highly technical nature, involving
        enterprise application development, enhancement, production deployment
        and support. ATC has helped us deliver many of our highly mission
        critical projects for us and our clients, and we are very happy about
        their commitment in the delivery of each and every engagement. ATC has
        played an instrumental role in helping us deliver multi-million dollar
        projects and we are looking forward to working with them in the future
        opportunities as well.&quot;
      </>
    ),
    author: (
      <>
        <span className="bold">Vinayak Hegde</span>
        <br />
        President, Sage Assurity Financial, Inc.
      </>
    ),
    bgImage: 'about/client-2.png',
    logo: 'testimonials/logo-SageAssurity.jpg',
  },
  {
    id: 3,
    comment: (
      <>
        &quot;Training programs combined with implementation support is a good
        proposition that helps retain learning for project teams.&quot;
      </>
    ),
    author: (
      <>
        <span className="bold">Asif Ali</span>
        <br />
        Founder, KloudOne
      </>
    ),
    bgImage: 'about/client-3.png',
    logo: 'testimonials/logo-kloudone.png',
  },
];

export const courses = [
  {
    badge: 'https://safe-training.s3.us-east-2.amazonaws.com/lpm5.png',
    batchSize: 35,
    contactEmail: 'trainings@american-technology.net',
    courseExpansion: '',
    courseId: 5,
    courseName: 'Certified SAFe® Advanced Scrum Master',
    courseStatus: '',
    description:
      'Advancing Scrum Master servant leadership with the Scaled Agile Framework®',
    discountEndDate: '',
    endDate: '2021-06-09',
    enrollmentClosed: 0,
    enrollmentCount: 0,
    enrollmentMessage: '',
    fullName: 'Niel Magsombol',
    isActive: 0,
    location: 'Online Public Class',
    startDate: '2021-05-09',
    trainerId: 4,
    trainerName: 'Niel Magsombol',
    trainingId: '233635',
    venueAddress: 'Online',
    detailsPage:
      'https://learn.auzmor.com/store/american-technology/courses/233635',
    courseType: 'real',
  },
  {
    badge: 'https://safe-training.s3.us-east-2.amazonaws.com/lpm5.png',
    batchSize: 35,
    contactEmail: 'trainings@american-technology.net',
    courseExpansion: '',
    courseId: 5,
    courseName: 'Leading SAFe Certification Course',
    courseStatus: '',
    description:
      'Applying a Lean-Agile mindset with SAFe 5 Agilist Certification',
    discountEndDate: '',
    endDate: '2021-09-09',
    enrollmentClosed: 0,
    enrollmentCount: 0,
    enrollmentMessage: '',
    fullName: 'Niel Magsombol',
    isActive: 0,
    location: 'Online Public Class',
    startDate: '2021-05-09',
    trainerId: 4,
    trainerName: 'Niel Magsombol',
    trainingId: '233634',
    venueAddress: 'Online',
    detailsPage:
      'https://learn.auzmor.com/store/american-technology/courses/233634',
    courseType: 'real',
  },
  {
    badge: 'https://safe-training.s3.us-east-2.amazonaws.com/lpm5.png',
    batchSize: 35,
    contactEmail: 'trainings@american-technology.net',
    courseExpansion: '',
    courseId: 5,
    courseName: 'Certified SAFe® Lean Portfolio Manager',
    courseStatus: '',
    description: 'Aligning strategy with execution',
    discountEndDate: '',
    endDate: '2021-06-09',
    enrollmentClosed: 0,
    enrollmentCount: 0,
    enrollmentMessage: '',
    fullName: 'Niel Magsombol',
    isActive: 0,
    location: 'Online Public Class',
    startDate: '2021-05-09',
    trainerId: 4,
    trainerName: 'Niel Magsombol',
    trainingId: '233632',
    venueAddress: 'Online',
    detailsPage:
      'https://learn.auzmor.com/store/american-technology/courses/233632',
    courseType: 'real',
  },
  {
    badge:
      'https://safe-training.s3.us-east-2.amazonaws.com/aws-solnarch-associate.png',
    batchSize: 35,
    contactEmail: 'trainings@american-technology.net',
    courseExpansion: '',
    courseId: 5,
    courseName: 'AWS Certified Solutions Architect – Associate',
    courseStatus: '',
    description:
      'Elevate your AWS skills to new heights and earn one of the most sought-after and well-respected certifications in IT',
    discountEndDate: '',
    endDate: '2021-05-09',
    enrollmentClosed: 0,
    enrollmentCount: 0,
    enrollmentMessage: '',
    fullName: 'Niel Magsombol',
    isActive: 0,
    location: 'Online Public Class',
    startDate: '2021-05-09',
    trainerId: 4,
    trainerName: 'Niel Magsombol',
    trainingId: '233624',
    venueAddress: 'Online',
    detailsPage:
      'https://learn.auzmor.com/store/american-technology/courses/233624',
    courseType: 'real',
  },
  {
    courseName: 'SAFe POPM (5.0)',
    courseId: 6,
    trainingId: '233633',
    trainerId: 4,
    startDate: '2021-04-10',
    endDate: '2021-04-11',
    location: 'Online Public Class',
    venueAddress: 'Online',
    trainerName: 'Nisha Bajaj',
    fullName: 'Nisha Bajaj',
    discountEndDate: '2021-01-27T16:16:51.000Z',
    batchSize: 35,
    enrollmentClosed: 0,
    courseExpansion: 'SAFe Product Owner / Product Manager',
    enrollmentMessage: '',
    enrollmentCount: 11,
    description:
      'Delivering value through effective Program Increment execution.',
    contactEmail: 'trainings@american-technology.net',
    courseStatus: '',
    badge: 'https://safe-training.s3.us-east-2.amazonaws.com/popm5.png',
    isActive: 0,
    detailsPage:
      'https://learn.auzmor.com/store/american-technology/courses/233624',
    courseType: 'real',
  },
  {
    courseName: 'SAFe DevOps (5.0) SAMPLE',
    courseId: 6,
    trainingId: '233636',
    trainerId: 4,
    startDate: '2021-04-10',
    endDate: '2021-08-11',
    location: 'Online Public Class',
    venueAddress: 'Online',
    trainerName: 'Nisha Bajaj',
    fullName: 'Nisha Bajaj',
    discountEndDate: '2021-01-27T16:16:51.000Z',
    batchSize: 35,
    enrollmentClosed: 0,
    courseExpansion: '',
    enrollmentMessage: '',
    enrollmentCount: 11,
    description: 'Optimizing Your Value Stream',
    contactEmail: 'trainings@american-technology.net',
    courseStatus: '',
    badge: 'https://safe-training.s3.us-east-2.amazonaws.com/sdp5.png',
    isActive: 0,
    detailsPage:
      'https://learn.auzmor.com/store/american-technology/courses/233636',
    courseType: 'dummy',
  },
];
